var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"min-vh-100 d-flex"},[_c('Sidebar'),_c('main',{staticClass:"container-fluid py-2"},[_c('TopNav'),_vm._t("default")],2)],1),_c('Player')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }